import { useEffect } from 'react';
import styled from 'styled-components';

import Footer from '../../components/Footer';
import Navbar from './../../components/Navbar';
import Header from './Header';
import MarketingExperts from './MarketingExperts';
import Partners from './Partners';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>Home | ripify</title>
      <TopSection>
        <Navbar />
        <Header />
      </TopSection>
      <Partners />
      <MarketingExperts />
      <Footer />
    </>
  );
};

export default HomePage;

const TopSection = styled.div`
  background: #edf2f5;
`;
